import { useState } from 'react';

const faqs = [
  {
    q: '牛牛影视需要注册会员才能观看吗？',
    a: '不需要。牛牛影视坚持免费开放原则，所有影视资源均可直接观看，无需注册、无需登录、无需付费，打开即看，全程无门槛。',
  },
  {
    q: '播放卡顿或画质模糊怎么办？',
    a: '牛牛影视配备自适应码率技术，播放器会根据当前网络状况自动调整清晰度。如遇卡顿，建议检查网络连接或手动切换至标清模式。牛牛不缓冲引擎已对主流网络环境深度优化，绝大多数场景下均能流畅播放。',
  },
  {
    q: '支持哪些设备观看？',
    a: '牛牛影视全面支持电脑（Windows / macOS）、平板（iPad / Android Pad）和手机（iOS / Android）多端观影。推荐使用Chrome、Safari等主流浏览器获得最佳体验。',
  },
  {
    q: '片库多久更新一次内容？',
    a: '牛牛影视每日更新片库，平均日增超过200部影视资源。热门新剧上线后24小时内即可在平台找到超清版本，经典老片也在持续补全中。',
  },
  {
    q: '如何向牛牛影视推荐想看的影片？',
    a: '欢迎通过「联系我们」模块提交你的观影需求。牛牛影视团队会定期整理用户推荐，优先补充呼声最高的影视资源，让你的心愿片单不再等待。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          关于牛牛影视，你可能想了解的一切
        </p>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-heading text-foreground-900 pr-2">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 md:w-7 md:h-7 rounded-full flex items-center justify-center shrink-0 transition-colors duration-200 ${
                  openIdx === idx ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-60 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}